"use client";
import React from "react";
import dynamic from "next/dynamic";
import styles from "./career-find.module.scss";
const Button = dynamic(() => import("@/Components/Button"));

interface CareerFindProps {
  data?: any;
}
const CareerFind = ({ data }: CareerFindProps) => {
  return (
    <>
      <section className="relative z-[0] overflow-hidden py-[56px] lg:py-[80px] xl:py-[100px] bg-white before:content-[''] before:absolute before:h-[100%] before:inset-0 before:bg-[url('/images/client-bg.png')] before:bg-no-repeat before:bg-[length:100%_100%] before:bg-center before:bg-[#F0F8FF] before:-z-10">
        <div className="container">
          <div
            className={`${styles.headingCareer} mb-[32px] lg:mb-[32px] xl:mb-[40px] max-w-[850px] mx-auto`}
          >
            <h2 className="text-center font-bold text-primary-text text-heading-1 mb-[12px]">
              {data?.title}
            </h2>
          </div>
          <div className="flex items-center justify-center">
            {data?.ready_made?.label && data?.ready_made?.href && (
              <Button
                variant="small"
                className="my-0"
                label={
                  data?.ready_made?.label ? (
                    <a href={data?.ready_made?.href}>
                      {data?.ready_made?.label}
                    </a>
                  ) : (
                    <a href="mailto:careers@trootech.com">Send Mail</a>
                  )
                }
              />
            )}
          </div>
        </div>
      </section>
    </>
  );
};
export default CareerFind;
